import { render, staticRenderFns } from "./WorkOrders.vue?vue&type=template&id=2d3472c0"
import script from "./WorkOrders.vue?vue&type=script&lang=js"
export * from "./WorkOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports